import { AppActions } from './app.actions';

const app = {
    loading: false,
    error: false
}

export const appReducer = (cState = app, action) => {
    switch (action.type) {
        default:
            return cState
        case AppActions.APP_LOADING:
            return { ...cState, loading: true, error: false }
        case AppActions.APP_ERROR:
            return { ...cState, loading: false, error: action.payload }
    }
}


// WEBPACK FOOTER //
// ./src/app/root/app.reducer.js